import styled from '@emotion/styled';

const SettingsFieldTitle = styled('h4')({
  marginBottom: 8,
  fontWeight: 400,
});

export default SettingsFieldTitle;
